import { useEffect, useState, useMemo } from "react";

function useMutationObserver(options, target, attributeName) {
  const [screen, setScreen] = useState();

  const func = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.attributeName === attributeName) {
        setScreen(document.documentElement?.getAttribute(attributeName));
      }
    }
  };

  const observer = useMemo(() => new MutationObserver(func));

  useEffect(() => {
    setScreen(document.documentElement?.getAttribute(attributeName));
  }, []);

  useEffect(() => {
    if (!observer) return;
    const { config } = options;
    observer.observe(target, config);
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [observer, target, options]);

  return screen;
}

export default useMutationObserver;
